module.exports = __webpack_public_path__ + "static/media/dusko.1a5dce57.jpg";